









































import Embeddable from '@/components/Common/Embeddable.vue';
import SuburbReport from '@/components/SuburbReport.vue';
import { AsyncView, RouteMeta } from 'client-website-ts-library/plugins';
import { API } from 'client-website-ts-library/services';
import { Blog } from 'client-website-ts-library/types';
import { Component, Mixins } from 'vue-property-decorator';

@Component({
  components: {
    Embeddable,
    SuburbReport,
  },
})
export default class BlogDetails extends Mixins(AsyncView) {
  private blog: Blog | null = null;

  private enableSuburbForm = false;

  mounted() {
    const blogId = this.$route.params.id;

    API.Blogs.Get(blogId).then((blog) => {
      this.blog = blog;
      this.$emit('updateView');
    });
  }

  openSuburbForm() {
    this.enableSuburbForm = true;
  }

  stripHtml(html: string, limit: number): string {
    const tmp = document.createElement('div');

    tmp.innerHTML = html;

    const text = tmp.innerText;

    return text.length < (limit * 1.2) ? text : `${tmp.innerText.substring(0, limit)}...`;
  }

  public head(): RouteMeta {
    return {
      title: `${this.blog?.Title} - ${this.blog?.Subtitle}`,
      description: this.stripHtml(this.blog?.Paragraph1 ?? '', 100),
      image: this.blog?.Images.length ? this.blog?.Images[0].Preview.Url : undefined,
    };
  }

  handleError(err: Response) {
    if (err.status === 403) {
      this.$router.push({
        path: '/blogs',
        query: {
          next: `/blogs/${this.$route.params.id}`,
        },
      });
    }
  }
}
